import CommonMiddleware from './common.middleware';
import pricingMiddleware from './pricing.middleware';
export * from './common.middleware';

const middlewares = [CommonMiddleware, pricingMiddleware];

export default middlewares;
